import { FolderCloud, Home } from "@layer/icons";
import type { AppRouteType } from "@layer/utils/lib/routing";

export const routes: AppRouteType[] = [
	{
		name: "Home",
		href: "/",
		hidden: true,
		icon: Home,
	},
] as const;
